import { render, staticRenderFns } from "./ModalAddFolder.vue?vue&type=template&id=dbc4201c&"
import script from "./ModalAddFolder.vue?vue&type=script&lang=ts&"
export * from "./ModalAddFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports